export interface DeferredPreviewLineFlags {
  deferred?: boolean;
  excludedFromAmountDue?: boolean;
}

/**
 * Bulk/single Confirm Enrollment Scheduled labels:
 * - ES12 immediate session fees send `deferred: false` even when excluded onto
 *   a separate SESSION txn. That boolean wins so they stay unlabeled.
 * - ES08 future tuition/membership/costume may omit `deferred` and only send
 *   `excludedFromAmountDue`. Fall back so those still show (Scheduled).
 */
export const isDeferredPreviewLineItem = (
  line: DeferredPreviewLineFlags,
): boolean =>
  typeof line.deferred === 'boolean'
    ? line.deferred
    : Boolean(line.excludedFromAmountDue);

export const getPreviewLineScheduledSuffix = (
  line: DeferredPreviewLineFlags,
): string => (isDeferredPreviewLineItem(line) ? ' (Scheduled)' : '');
